package com.nonopn.skywatcher.design.utils

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

enum class WindowType {
    SMARTPHONE_TINY,
    SMARTPHONE,
    PHABLET,
    TABLET;

    fun isScreenExpanded() = when (this) {
        WindowType.SMARTPHONE_TINY -> false
        WindowType.SMARTPHONE -> false
        WindowType.PHABLET -> true
        WindowType.TABLET -> true
    }

    // Factory method that creates an instance of the class based on window width
    companion object {
        fun basedOnWidth(windowWidth: Dp): WindowType = when {
            windowWidth < 250.dp -> SMARTPHONE_TINY
            windowWidth < 450.dp -> SMARTPHONE
            windowWidth < 700.dp -> PHABLET
            else -> TABLET
        }
    }
}
